import styled from '@emotion/styled';
import { useLocation } from 'react-router-dom';
import { getColor } from '../../../theme/colors/colors';
import { useWorkspace } from '../../../context/WorkspaceContext';
import WorkspaceSwitcher from './WorkspaceSwitcher';

interface RouteConfig {
  title: string;
  subtitle: string;
}

const getRouteConfig = (pathname: string): RouteConfig => {
  if (pathname.startsWith('/organization')) {
    return { title: 'Organizations', subtitle: 'Manage client organizations and their details' };
  }
  if (pathname.startsWith('/buyer-seat')) {
    return { title: 'Buyer Seats', subtitle: 'Manage buyer seats across SSP platforms' };
  }
  return { title: 'Deals', subtitle: 'View and manage all deals' };
};

const PageHeader = () => {
  const location = useLocation();
  const { isAdmin } = useWorkspace();
  const { title, subtitle } = getRouteConfig(location.pathname);
  const isDealPage = location.pathname.startsWith('/deal');

  return (
    <HeaderWrapper>
      <TitleSection>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </TitleSection>
      {isAdmin && isDealPage && <WorkspaceSwitcher />}
    </HeaderWrapper>
  );
};

export default PageHeader;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 48px 12px;
  border-bottom: 1px solid #0000001a;
  background-color: #ffffff;
  margin: -56px -48px 24px;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h4`
  color: ${getColor('text')};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.31px;
  margin: 0;
`;

const Subtitle = styled.p`
  color: ${getColor('text')};
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  opacity: 0.6;
  margin: 4px 0 0;
`;
